import { useMutation } from '@tanstack/react-query';
import { postClientPortalToken } from 'api/resources/clientPortal';

export const usePostClientPortalToken = () => {
	return useMutation({
		mutationFn: postClientPortalToken,
	});
};
